import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Container } from "../../../components/Container";
import {
	Input,
	Button,
	Table,
	Space,
	notification,
	Modal,
	Menu,
	Dropdown,
	Tag,
	Spin,
	Card,
	message,
	Typography,
	Alert,
	Form,
	Upload,
	Descriptions,
	Divider,
} from "antd";
import { useContext } from "react";
import { SecurityContext } from "../../../context/SecurityContextProvider";
import { CheckCircleFilled, LoadingOutlined, WarningOutlined } from "@ant-design/icons";

import {
	FileExcelOutlined,
	UnorderedListOutlined,
	PlusOutlined,
	SearchOutlined,
	UploadOutlined,
	EditOutlined,
	ExclamationCircleOutlined,
	LockOutlined,
	UnlockOutlined,
	CloseOutlined,
	CheckOutlined,
	ContainerOutlined,
	DownloadOutlined,
	KeyOutlined,
	MailOutlined,
	RollbackOutlined,
	CaretDownOutlined,
	ContactsOutlined,
	UserOutlined,
	FieldNumberOutlined,
	PictureOutlined,
	Loading3QuartersOutlined,
	CopyOutlined,
	LineChartOutlined,
	SyncOutlined,
	FilePdfOutlined,
	FileSearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";

import ColaboradorService from "../../../services/ColaboradorService";
import DetalleEnvioService from "../../../services/DetalleEnvioService";
import ModalVisorPdf from "../../../components/common/ModalVisorPdf/ModalVisorPdf";
import ModalCargaMasiva from "../carga-masiva/modalCargaMasiva";
import MenuItem from "antd/lib/menu/MenuItem";
import { tipoDocumentoIdentidad } from "../../../enums/TipoDocumentoIdentidad";
import { saveAs } from "file-saver";
import {
	visibleModalRestablecerClaveAtom,
	visibleModalReingresoColaboradorAtom,
	visibleModalExportarFormularioAtom,
	visibleModalVerificacionEnvioDocumentoAtom,
	eventoDescargaAtom,
	visibleModalConfigurarOpcionPortalColaboradorAtom,
	visibleModalVisualizarResumenAtom
} from "./ColaboradorListarStore";
import { useAtom } from "jotai";
import { DrawerActualizarColaboradores, ModalExportarFormulario, ModalReporteVerificacionEnvioDocumento, ModalRestablecerClave } from "../listar/componentes";
import { ModalReingreso } from "../listar/componentes/ModalReingreso";
import { ModalHabilitarOpcionPortalColaborador } from "../listar/componentes/ModalHabilitarOpcionPortalColaborador";
import { visibleModalHistorialCodigosAtom } from "./ColaboradorListarStore";
import { ModalHistorialColaborador } from "./historialColaborador";
import { historialCodigosAtom } from "./ColaboradorListarStore";
import HistorialColaboradorService from "../../../services/HistorialColaboradorService";
import { FiltroBusqueda } from "./componentes/FiltroBusqueda";
import { useParams } from "react-router-dom";
import { EstadoColaboradorTag } from "./componentes/EstadoColaboradorTag";
import { OPCIONES } from "enums";
import { ExportadorService } from "services";
import { usePermisos } from "hooks";
import { ModalVisualizarResumen } from "./componentes/ModalVisualizarResumen";
import { useDrawerActualizarColaboradores } from "./hooks";
import { ModalActualizarEstadoRegistro } from "../modal-ctualizar-estado-registro";
import { ModalActualizarAprobadoresNivel } from "../modal-actualizar-aprobadores-nivel";

export function ColaboradorListarPage() {
	//const [vinculoLaboral] = useState(searchParams.get("vinculoLaboral"));
	const [colaboradores, setColaboradores] = useState();
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [visibleModal, SetVisibleModal] = useState(false);
	const [, setVisibleModalRestablecerClave] = useAtom(visibleModalRestablecerClaveAtom);
	const [colaboradorSeleccionado, setColaboradorSeleccionado] = useState("");
	const [objetoColaboradorSeleccionado, setObjetoColaboradorSeleccionado] = useState("");
	const [, setVisibleModalHistorialCodigos] = useAtom(visibleModalHistorialCodigosAtom);
	const [, setHistorialCodigos] = useAtom(historialCodigosAtom);
	const [loading, setLoading] = useState(false);
	const [paginaActual, setPaginaActual] = useState(0);
	const [totalPagina, setTotalPagina] = useState(0);
	const [filtros, setFiltros] = useState(undefined);
	const [reset, setReset] = useState(false);
	const [sortInfo, setSortInfo] = useState({ field: undefined, dir: undefined });
	const [loadingNotificar, setLoadingNotificar] = useState(false);
	const [loadingMigrar, setLoadingMigrar] = useState(false);
	const [loadingExportar, setLoadingExportar] = useState(false);
	const [loadingExportarAsync, setLoadingExportarAsync] = useState(false);
	const [, setVisibleModalReingresoColaborador] = useAtom(visibleModalReingresoColaboradorAtom);
	const [, setVisibleModalExportarFormulario] = useAtom(visibleModalExportarFormularioAtom);
	const [, setVisibleModalVerificacionEnvioDocumento] = useAtom(visibleModalVerificacionEnvioDocumentoAtom);
	const [eventoDescarga, setEventoDescarga] = useAtom(eventoDescargaAtom);
	const { fetchOpciones, existeOpcion } = usePermisos();
	const [visibleVisualizarResumen, setVisibleVisualizarResumen] = useAtom(visibleModalVisualizarResumenAtom);
	const { abrirDrawer: abrirDrawerActualizarColaboradores } = useDrawerActualizarColaboradores();

	const [visibleModalActualizarAprobadores, setVisibleModalActualizarAprobadores] = useState(false);

	const [visibleModalEditarDocumento, setVisibleModalEditarDocumento] = useState(false);
	const [colaboradorParaEditar, setColaboradorParaEditar] = useState(null);
	const [loadingEditarDocumento, setLoadingEditarDocumento] = useState(false);
	const [formEditarDocumento] = Form.useForm();

	const [colaboradorCV, setColaboradorCV] = useState(null);
	const [visibleModalCV, setVisibleModalCV] = useState(false);
	const [visibleVisorCV, setVisibleVisorCV] = useState(false);
	const [urlCV, setUrlCV] = useState(null);
	const [loadingCargarCV, setLoadingCargarCV] = useState(false);
	const [cvDetalleEnvio, setCvDetalleEnvio] = useState(null);
	const [loadingCV, setLoadingCV] = useState(false);

	let history = useHistory();

	const isAceros = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("ACEROS CHILCA SAC")
		? true
		: false;

	const isExplomin = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837" ? true : false;
	const isLaredo = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20132377783" ? true : false;

	const opcionesEmpresaSeleccionada = getUsuarioAutenticado().empresaSeleccionada.opciones;
	const [, setVisibleModalConfigurarOpcionPortalColaborador] = useAtom(visibleModalConfigurarOpcionPortalColaboradorAtom);
    const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;

	const [visibleModalActualizarEstado, setVisibleModalActualizarEstado] = useState(false);

	const isGlore =
		getUsuarioAutenticado().empresaSeleccionada?.ruc === "20555936045"
		? true
		: false;

	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

    const handleOnClickActualizarEstadoRegistro = () => {
        setVisibleModalActualizarEstado(true);
    };

    const handleCerrarModalActualizarEstado = () => {
        setVisibleModalActualizarEstado(false);
    };

    const handleSuccessActualizarEstado = () => {
        // Recargar la tabla o hacer lo que necesites
        //cargarColaboradores();
    };

	useEffect(() => {
		fetchOpciones();
	}, []);

	async function handleOnOkQuitarAccesoPlataforma(colaboradorId) {
		await ColaboradorService.quitarAccesoPlataforma(colaboradorId);
		setColaboradores(
			colaboradores.map((colaborador) => {
				if (colaborador.id === colaboradorId) {
					return { ...colaborador, tieneAccesoPlataforma: false };
				}
				return colaborador;
			})
		);
		notification.success({
			message: "Operación exitosa",
			description: "Se ha quitado el acceso a la plataforma al colaborador correctamente.",
		});
	}
	async function handleOnOkHabilitarAccesoPlataforma(colaboradorId) {
		await ColaboradorService.habilitarAccesoPlataforma(colaboradorId);
		setColaboradores(
			colaboradores.map((colaborador) => {
				if (colaborador.id === colaboradorId) {
					return { ...colaborador, tieneAccesoPlataforma: true };
				}
				return colaborador;
			})
		);
		notification.success({
			message: "Operación exitosa",
			description: "Se ha habilitado el acceso a la plataforma al colaborador correctamente.",
		});
	}

	async function listarHistorialCambios(idColaborador) {
		const historial = await HistorialColaboradorService.listarHistorialCodigos(
			getUsuarioAutenticado().empresaSeleccionada.id,
			idColaborador
		);
		setHistorialCodigos(historial);
	}
	function handleOnclickMenu({ item, key }) {
		if (key === "1" && item.props.colaborador.tieneAccesoPlataforma) {
			Modal.confirm({
				title: "¿Está seguro de quitar el acceso a la plataforma al colaborador?",
				icon: <ExclamationCircleOutlined />,
				okText: "Si",
				cancelText: "No",
				onOk() {
					handleOnOkQuitarAccesoPlataforma(item.props.colaborador.id);
				},
			});
		} else if (key === "1" && !item.props.colaborador.tieneAccesoPlataforma) {
			Modal.confirm({
				title: "¿Está seguro de habilitar el acceso a la plataforma al colaborador?",
				icon: <ExclamationCircleOutlined />,
				okText: "Si",
				cancelText: "No",
				onOk() {
					handleOnOkHabilitarAccesoPlataforma(item.props.colaborador.id);
				},
			});
		} else if (
			key === "2" &&
			(item.props.colaborador.estadoRegistro === "ACTIVO" || item.props.colaborador.estadoRegistro === null)
		) {
			Modal.confirm({
				title: "¿Está seguro de cesar al colaborador seleccionado?",
				// content: (
				// 	<div style={{ display: "flex", alignItems: "flex-start" }}>
				// 		<WarningOutlined style={{ fontSize: "20px", color: "#dc3545" }} />
				// 		<Typography.Text style={{ marginLeft: "8px", wordWrap: "break-word" }}>
				// 			Se borrará toda la informacion del colaborador.
				// 		</Typography.Text>
				// 	</div>
				// ),
				icon: <ExclamationCircleOutlined />,
				okText: "si",
				cancelText: "No",
				onOk() {
					handleOnOkDesactivarColaborador(item.props.colaborador.id);
				},
			});
		} else if (key === "2" && item.props.colaborador.estadoRegistro === "CESADO") {
			Modal.confirm({
				title: "Está seguro de activar al colaborador seleccionado?",
				icon: <ExclamationCircleOutlined />,
				okText: "si",
				cancelText: "No",
				onOk() {
					handleOnOkActivarColaborador(item.props.colaborador.id);
				},
			});
		} else if (key === "4") {
			setVisibleModalRestablecerClave(true);
			setColaboradorSeleccionado(item.props.colaborador.numeroDocumentoIdentidad);
		} else if (key === "5") {
			listarHistorialCambios(item.props.colaborador.id);
			setVisibleModalHistorialCodigos(true);
		} else if (key === "6") {
			Modal.confirm({
				title: "Está seguro de eliminar al colaborador seleccionado?",
				icon: <ExclamationCircleOutlined />,
				okText: "si",
				cancelText: "No",
				onOk() {
					handleOnOkEliminarColaborador(item.props.colaborador.id);
				},
			});
		} else if (key === "7") {
			setVisibleModalReingresoColaborador(true);
			//setVisibleModalRestablecerClave(true);
			setColaboradorSeleccionado(item.props.colaborador.numeroDocumentoIdentidad);
		} else if (key === "8") {
			setVisibleModalConfigurarOpcionPortalColaborador(true);
			setColaboradorSeleccionado(item.props.colaborador.numeroDocumentoIdentidad);
			setObjetoColaboradorSeleccionado(item.props.colaborador);
		} else if (key === "9") {
			setColaboradorParaEditar(item.props.colaborador);
			setVisibleModalEditarDocumento(true);
		} else if (key === "10") {
			handleVerCV(item.props.colaborador);
		}
	}

	const menu = (colaborador) => (
		<Menu onClick={handleOnclickMenu}>

			{
				colaborador.tieneAccesoPlataforma ? (
					<Menu.Item key="1" colaborador={colaborador}>
						<LockOutlined /> Quitar Acceso a la Plataforma
					</Menu.Item>
				) : (
					<Menu.Item key="1" colaborador={colaborador}>
						<UnlockOutlined /> Habilitar Acceso a la Plataforma
					</Menu.Item>
				)
			}

			{
				colaborador.estadoRegistro === "ACTIVO" || colaborador.estadoRegistro === null ? (
					<Menu.Item key="2" colaborador={colaborador}>
						<CloseOutlined /> Cesar
					</Menu.Item>
				) : (
					<Menu.Item key="2" colaborador={colaborador}>
						<CheckOutlined /> Activar
					</Menu.Item>
				)
			}

			<MenuItem key="3" colaborador={colaborador}>
				<ContainerOutlined /> Legajo
			</MenuItem>

			<MenuItem key="4" colaborador={colaborador}>
				<KeyOutlined /> Restablecer Clave
			</MenuItem>


			<MenuItem key="5" colaborador={colaborador}>
				<KeyOutlined /> Ver histórico de cambios
			</MenuItem>

			{isAceros && (
				<MenuItem key="6" colaborador={colaborador}>
					<CloseOutlined /> Eliminar colaborador
				</MenuItem>
			)}

			{isExplomin
				&& colaborador?.estadoRegistro === "CESADO"
				&& (
					<MenuItem key="7" colaborador={colaborador}>
						<RollbackOutlined /> Reingresar colaborador
					</MenuItem>
				)}

			{isExplomin
				&& (
					<MenuItem key="8" colaborador={colaborador}>
						<CopyOutlined /> Habilitar opción Portal Colaborador
					</MenuItem>
				)}

			{existeOpcion(OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.TXT_EDITAR_NUMERO_DOCUMENTO_IDENTIDAD) && (
				<MenuItem key="9" colaborador={colaborador}>
					<ContactsOutlined /> Editar Número Documento Identidad
				</MenuItem>
			)}

			<MenuItem key="10" colaborador={colaborador}>
				<FilePdfOutlined /> Gestionar CV
			</MenuItem>
		</Menu>
	);

	const menuExplomin = (colaborador) => (
		<Menu onClick={handleOnclickMenu}>
			{
				existeOpcion("mantenimiento.colaborador.acceso-plataforma") &&
				(
					colaborador.tieneAccesoPlataforma ? (
						<Menu.Item key="1" colaborador={colaborador}>
							<LockOutlined /> Quitar Acceso a la Plataforma
						</Menu.Item>
					) : (
						<Menu.Item key="1" colaborador={colaborador}>
							<UnlockOutlined /> Habilitar Acceso a la Plataforma
						</Menu.Item>
					)
				)
			}

			{
				existeOpcion("mantenimiento.colaborador.cesar")
				&& isExplomin
				&& (colaborador.estadoRegistro === "ACTIVO" || colaborador.estadoRegistro === null)
				&& (
					<Menu.Item key="2" colaborador={colaborador}>
						<CloseOutlined /> Cesar
					</Menu.Item>
				)
			}

			{
				existeOpcion("mantenimiento.colaborador.cesar")
				&& !isExplomin
				&& (
					colaborador.estadoRegistro === "ACTIVO" || colaborador.estadoRegistro === null ? (
						<Menu.Item key="2" colaborador={colaborador}>
							<CloseOutlined /> Cesar
						</Menu.Item>
					) : (
						<Menu.Item key="2" colaborador={colaborador}>
							<CheckOutlined /> Activar
						</Menu.Item>
					)
				)
			}

			{
				existeOpcion("mantenimiento.colaborador.legajo")
				&& (
					<MenuItem key="3" colaborador={colaborador}>
						<ContainerOutlined /> Legajo
					</MenuItem>
				)
			}

			{
				existeOpcion("mantenimiento.colaborador.restablecer-clave")
				&& (
					<MenuItem key="4" colaborador={colaborador}>
						<KeyOutlined /> Restablecer Clave
					</MenuItem>
				)
			}
			{
				existeOpcion("mantenimiento.colaborador.ver-historico-cambios")
				&& (
					<MenuItem key="5" colaborador={colaborador}>
						<KeyOutlined /> Ver histórico de cambios
					</MenuItem>
				)
			}

			{isAceros && (
				<MenuItem key="6" colaborador={colaborador}>
					<CloseOutlined /> Eliminar colaborador
				</MenuItem>
			)}

			{isExplomin
				&& existeOpcion("mantenimiento.colaborador.reingresar-colaborador")
				&& colaborador?.estadoRegistro === "CESADO"
				&& (
					<MenuItem key="7" colaborador={colaborador}>
						<RollbackOutlined /> Reingresar colaborador
					</MenuItem>
				)}

			{isExplomin
				&& existeOpcion("mantenimiento.colaborador.filtros-documentos-colaborador")
				&& (
					<MenuItem key="8" colaborador={colaborador}>
						<CopyOutlined /> Habilitar opción Portal Colaborador
					</MenuItem>
				)}

			{existeOpcion(OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.TXT_EDITAR_NUMERO_DOCUMENTO_IDENTIDAD) && (
				<MenuItem key="9" colaborador={colaborador}>
					<ContactsOutlined /> Editar Número Documento Identidad
				</MenuItem>
			)}

			<MenuItem key="10" colaborador={colaborador}>
				<FilePdfOutlined /> Gestionar CV
			</MenuItem>
		</Menu>
	);

	let columnas = [
		{
			title: "Tipo de Documento",
			dataIndex: "tipoDocumentoIdentidad",
			width: 120,
			align: "center",
			render: (text, fila) => (
				<React.Fragment>
					{fila.tipoDocumentoIdentidad == "CARNET_EXTRANJERIA" &&
						fila.tipoDocumentoIdentidad?.replace("CARNET_EXTRANJERIA", "CE")}
					{fila.tipoDocumentoIdentidad == "OTRO_DOCUMENTO" &&
						fila.tipoDocumentoIdentidad?.replace("OTRO_DOCUMENTO", "OD")}
					{fila.tipoDocumentoIdentidad != "OTRO_DOCUMENTO" &&
						fila.tipoDocumentoIdentidad != "OTRO_DOCUMENTO" &&
						fila.tipoDocumentoIdentidad}
				</React.Fragment>
			),
		},
		{
			title: "Documento",
			dataIndex: "numeroDocumentoIdentidad",
			align: "right",
			width: "5%",
		},
		{
			title: "Apellidos y Nombres",
			dataIndex: "nombreCompleto",
			sorter: true,
			sortDirections: ["ascend", "descend"],
			render: (text, fila) => (
				<Button type="text" onClick={() => onClickLegajoColaborador(fila.id)}>
					{fila.nombreCompleto}
				</Button>
			),
		},
		{
			title: "Código",
			dataIndex: "codigoTrabajador",
			align: "right",
			width: "5%",
			sorter: true,
			sortDirections: ["ascend", "descend"],
		},
		{
			title: "Correo Electrónico",
			dataIndex: "correoElectronico",
			render: (text, fila) => (
				<React.Fragment>
					{fila.correoElectronico !== null && fila.correoElectronicoVerificado === fila.correoElectronico ? (
						<span>
							{fila.correoElectronico}
							{"  "}
							<CheckCircleFilled style={{ fontSize: "20px", color: "#68BA39" }} />
						</span>
					) : (
						<>
							<div>{fila.correoElectronico}</div>
							<div>{fila.correoElectronicoAlternativo}</div>
						</>
					)}
				</React.Fragment>
			),
		},
		{
			title: "Acceso",
			dataIndex: "tieneAccesoPlataforma",
			align: "center",
			width: "10%",
			//...getColumnSearchProps("estadoAccesoPlataforma"),
			render: (text, fila) => (
				<React.Fragment>
					{fila.tieneAccesoPlataforma ? <Tag color="green">SI</Tag> : <Tag color="red">NO</Tag>}
				</React.Fragment>
			),
		},
		{
			title: "Estado",
			dataIndex: "estadoRegistro",
			align: "center",
			width: "10%",
			render: (_, fila) => <EstadoColaboradorTag estado={fila.estadoRegistro} />,
		},
		{
			title: "Acciones",
			align: "center",
			align: "center",
			render: (text, fila) => (
				<Space size={8}>
					<a onClick={() => handleOnClickEditarColaborador(fila.id)} className="custom-color-element">
						<EditOutlined /> Editar
					</a>
					<Dropdown overlay={() => menu(fila)}>
						<a className="custom-color-element" onClick={(e) => e.preventDefault()}>
							<UnorderedListOutlined /> Otros
						</a>
					</Dropdown>
				</Space>
			),
		},
	];

	if (isSDFEnergia || isSDF) {
		columnas.splice(columnas.length - 1, 0, {
			title: "Fecha Ingreso",
			dataIndex: "fechaIngreso",
			align: "center",
			width: "10%",
			sorter: true,
			sortDirections: ["ascend", "descend"],
			render: (text) => {
				if (!text) return "";
				const datePart = text.split("T")[0];
				return datePart.split("-").reverse().join("/");
			},
		});
	}

	if (isExplomin) {
		columnas = [
			{
				title: "Colaborador",
				width: "25%",
				render: (text, fila) => (
					<>
						<div>
							<Button
								type="text"
								style={{ padding: "0px", paddingInline: "0px" }}
								onClick={() => onClickLegajoColaborador(fila.id)}
							>
								<Space>
									<UserOutlined style={{ fontSize: "18px" }} />
									<span style={{ borderBottom: "1px dashed #607D8B" }}>{fila.nombreCompleto}</span>
								</Space>
							</Button>
						</div>
						<div>
							{fila.tipoDocumentoIdentidad == "CARNET_EXTRANJERIA" && (
								<Space>
									<ContactsOutlined style={{ fontSize: "18px" }} />
									{fila.tipoDocumentoIdentidad?.replace("CARNET_EXTRANJERIA", "CE")}:
									{fila.numeroDocumentoIdentidad}
								</Space>
							)}
							{fila.tipoDocumentoIdentidad == "OTRO_DOCUMENTO" && (
								<Space>
									<ContactsOutlined style={{ fontSize: "18px" }} />
									{fila.tipoDocumentoIdentidad?.replace("OTRO_DOCUMENTO", "OD")}:
									{fila.numeroDocumentoIdentidad}
								</Space>
							)}
							{fila.tipoDocumentoIdentidad != "OTRO_DOCUMENTO" &&
								fila.tipoDocumentoIdentidad != "CARNET_EXTRANJERIA" && (
									<Space>
										<ContactsOutlined style={{ fontSize: "18px" }} />
										<span>
											{fila.tipoDocumentoIdentidad}: {fila.numeroDocumentoIdentidad}
										</span>
									</Space>
								)}
						</div>
						<div>
							<Space>
								<FieldNumberOutlined style={{ fontSize: "18px" }} />
								Código : {fila.codigoTrabajador}
							</Space>
						</div>
					</>
				),
			},
			{
				title: "Correo Electrónico",
				dataIndex: "correoElectronico",
				render: (text, fila) => (
					<React.Fragment>
						{fila.correoElectronico !== null &&
							fila.correoElectronicoVerificado === fila.correoElectronico ? (
							<span>
								{fila.correoElectronico}
								{"  "}
								<CheckCircleFilled style={{ fontSize: "20px", color: "#68BA39" }} />
							</span>
						) : (
							fila.correoElectronico
						)}
					</React.Fragment>
				),
			},
			{
				title: "Proyecto",
				dataIndex: ["seccion", "nombre"],
				width: "15%",
			},
			{
				title: "Reclutador",
				dataIndex: "usuarioRegistro",
				width: "20%",
			},
			{
				title: "Acceso",
				dataIndex: "tieneAccesoPlataforma",
				align: "center",
				width: "5%",
				//...getColumnSearchProps("estadoAccesoPlataforma"),
				render: (text, fila) => (
					<React.Fragment>
						{fila.tieneAccesoPlataforma ? <Tag color="green">SI</Tag> : <Tag color="red">NO</Tag>}
					</React.Fragment>
				),
			},
			{
				title: "Estado",
				dataIndex: "estadoRegistro",
				align: "center",
				width: "5%",
				render: (_, fila) => <EstadoColaboradorTag estado={fila.estadoRegistro} />,
			},
			{
				title: "Acciones",
				align: "center",
				width: "5%",
				render: (text, fila) => (
					<Space size={8}>
						{existeOpcion("mantenimiento.colaborador.editar")
							&& fila.estadoRegistro !== "CESADO"
							&& (
								<a onClick={() => handleOnClickEditarColaborador(fila.id)} className="custom-color-element">
									<EditOutlined /> Editar
								</a>
							)
						}

						< Dropdown overlay={() => menuExplomin(fila)}>
							<a className="custom-color-element" onClick={(e) => e.preventDefault()}>
								<UnorderedListOutlined /> Otros
							</a>
						</Dropdown >
					</Space >
				),
			},
		];
	}

	if (isLaredo) {
		columnas = [
			{
				title: "Colaborador",
				width: "25%",
				render: (text, fila) => (
					<>
						<div>
							<Button
								type="text"
								style={{ padding: "0px", paddingInline: "0px" }}
								onClick={() => onClickLegajoColaborador(fila.id)}
							>
								<Space>
									<UserOutlined style={{ fontSize: "18px" }} />
									<span style={{ borderBottom: "1px dashed #607D8B" }}>{fila.nombreCompleto}</span>
								</Space>
							</Button>
						</div>
						<div>
							{fila.tipoDocumentoIdentidad === "CARNET_EXTRANJERIA" && (
								<Space>
									<ContactsOutlined style={{ fontSize: "18px" }} />
									{fila.tipoDocumentoIdentidad?.replace("CARNET_EXTRANJERIA", "CE")}:
									{fila.numeroDocumentoIdentidad}
								</Space>
							)}
							{fila.tipoDocumentoIdentidad === "OTRO_DOCUMENTO" && (
								<Space>
									<ContactsOutlined style={{ fontSize: "18px" }} />
									{fila.tipoDocumentoIdentidad?.replace("OTRO_DOCUMENTO", "OD")}:
									{fila.numeroDocumentoIdentidad}
								</Space>
							)}
							{fila.tipoDocumentoIdentidad !== "OTRO_DOCUMENTO" &&
								fila.tipoDocumentoIdentidad !== "CARNET_EXTRANJERIA" && (
									<Space>
										<ContactsOutlined style={{ fontSize: "18px" }} />
										<span>
											{fila.tipoDocumentoIdentidad}: {fila.numeroDocumentoIdentidad}
										</span>
									</Space>
								)}
						</div>
						<div>
							<Space>
								<FieldNumberOutlined style={{ fontSize: "18px" }} />
								Código: {fila.codigoTrabajador}
							</Space>
						</div>
						<div>
							<Space>
								<MailOutlined style={{ fontSize: "18px" }} />
								{fila.correoElectronico !== null &&
									fila.correoElectronicoVerificado === fila.correoElectronico ? (
									<span>
										{fila.correoElectronico}
										{"  "}
										<CheckCircleFilled style={{ fontSize: "20px", color: "#68BA39" }} />
									</span>
								) : (
									fila.correoElectronico
								)}
							</Space>

						</div>
					</>
				),
			},
			// {
			// 	title: "Correo Electrónico",
			// 	dataIndex: "correoElectronico",
			// 	render: (text, fila) => (
			// 		<React.Fragment>
			// 			{fila.correoElectronico !== null &&
			// 				fila.correoElectronicoVerificado === fila.correoElectronico ? (
			// 				<span>
			// 					{fila.correoElectronico}
			// 					{"  "}
			// 					<CheckCircleFilled style={{ fontSize: "20px", color: "#68BA39" }} />
			// 				</span>
			// 			) : (
			// 				fila.correoElectronico
			// 			)}
			// 		</React.Fragment>
			// 	),
			// },
			{
				title: "Perfil",
				dataIndex: ["perfil", "nombre"],
				width: "15%",
			},
			{
				title: "Gerencia",
				dataIndex: ["subsede", "nombre"],
				width: "15%",
			},
			{
				title: "Área",
				dataIndex: ["seccion", "nombre"],
				width: "15%",
			},
			{
				title: "Departamento",
				dataIndex: ["tipoPlanilla", "nombre"],
				width: "15%",
			},
			{
				title: "Cargo",
				dataIndex: ["cargo", "nombre"],
				width: "15%",
			},
			{
				title: "Acceso",
				dataIndex: "tieneAccesoPlataforma",
				align: "center",
				width: "5%",
				//...getColumnSearchProps("estadoAccesoPlataforma"),
				render: (text, fila) => (
					<React.Fragment>
						{fila.tieneAccesoPlataforma ? <Tag color="green">SI</Tag> : <Tag color="red">NO</Tag>}
					</React.Fragment>
				),
			},
			{
				title: "Estado",
				dataIndex: "estadoRegistro",
				align: "center",
				width: "5%",
				render: (_, fila) => <EstadoColaboradorTag estado={fila.estadoRegistro} />,
			},
			{
				title: "Acciones",
				align: "center",
				width: "5%",
				render: (text, fila) => (
					<Space size={8}>
						<a onClick={() => handleOnClickEditarColaborador(fila.id)} className="custom-color-element">
							<EditOutlined /> Editar
						</a>
						<Dropdown overlay={() => menu(fila)}>
							<a className="custom-color-element" onClick={(e) => e.preventDefault()}>
								<UnorderedListOutlined /> Otros
							</a>
						</Dropdown>
					</Space>
				),
			},
		];
	}

	async function actualizarData(pagina, sort) {

		setLoading(true);

		const _accesoPlataforma = filtros["accesoPlataforma"]?.map((p) => {
			return p.replace("SI", true).replace("NO", false);
		});
		const _tipoDocumento = filtros["tipoDocumento"]?.map((p) => {
			return p.replace("Carnet de Extranjería", "CARNET_EXTRANJERIA").replace("Pasaporte", "PASAPORTE");
		});
		const _sort = sort ?? sortInfo;
		const _colaboradores = await ColaboradorService.listarPaginado(
			"TRABAJADOR",
			getUsuarioAutenticado().empresaSeleccionada.id,
			_accesoPlataforma,
			filtros["estado"],
			_tipoDocumento,
			filtros["colaborador"],
			filtros["documentoIdentidad"],
			filtros["codigoColaborador"],
			filtros["centroCosto"],
			filtros["proyecto"],
			filtros["reclutador"],
			filtros["sede"],
			filtros["cargo"],
			filtros["perfil"],
			filtros["subsede"],
			filtros["seccion"],
			filtros["planilla"],
			filtros["fechaIngreso"],
			getUsuarioAutenticado().login,
			pagina,
			_sort.field,
			_sort.dir
		);
		setColaboradores(_colaboradores.content);
		setTotalPagina(_colaboradores.totalElements);
		setReset(false);
		if (pagina === undefined) {
			setPaginaActual(1);
		}

		setLoading(false);
	}

	useEffect(() => {
		if (filtros != undefined) {
			setPaginaActual(1);
			actualizarData();
		}
	}, [filtros]);

	function handleOnClickCrearColaborador() {
		history.push(`/personal/trabajador/crear`);
	}

	function handleOnClickEditarColaborador(idColaborador) {
		history.push(`/personal/trabajador/editar/${idColaborador}`);
	}

	function handleOnClickCargaMasivaColaborador() {
		//history.push("/colaborador/carga-masiva");
		SetVisibleModal(true);
	}
	async function cerrarModal() {
		SetVisibleModal(false);
		setReset(true);
		setFiltros({});
	}

	async function handleOnOkDesactivarColaborador(colaboradorId) {
		await ColaboradorService.desactivarColaborador(colaboradorId);
		setColaboradores(
			colaboradores.map((colaborador) => {
				if (colaborador.id === colaboradorId) {
					return { ...colaborador, estadoRegistro: "CESADO" };
				}
				return colaborador;
			})
		);
		notification.success({
			message: "Operación exitosa",
			description: "Se ha desactivado el registro.",
		});
	}

	async function handleOnOkActivarColaborador(colaboradorId) {
		await ColaboradorService.activarColaborador(colaboradorId);
		setColaboradores(
			colaboradores.map((colaborador) => {
				if (colaborador.id === colaboradorId) {
					return { ...colaborador, estadoRegistro: "ACTIVO" };
				}
				return colaborador;
			})
		);
		notification.success({
			message: "Operación exitosa",
			description: "Se ha activado el registro.",
		});
	}
	async function handleOnOkEliminarColaborador(colaboradorId) {
		let respuesta = await ColaboradorService.eliminarColaborador(colaboradorId);
		console.log(respuesta);
		if (respuesta) {
			setColaboradores(colaboradores.filter((item) => item.id !== colaboradorId));
			notification.success({
				message: "Operación exitosa",
				description: "Se ha eliminado el registro.",
			});
		} else {
			notification.warning({
				message: "No se pude realizar la operación",
				description: "El colaborador tiene documentos asociados.",
			});
		}
	}

	async function handleOnclickExportarDatos() {
		setLoadingExportar(true);
		try {
			const _accesoPlataforma = filtros["accesoPlataforma"]?.map((p) => {
				return p.replace("SI", true).replace("NO", false);
			});
			const _tipoDocumento = filtros["tipoDocumento"]?.map((p) => {
				return p.replace("Carnet de Extranjería", "CARNET_EXTRANJERIA").replace("Pasaporte", "PASAPORTE");
			});

			let mostrarSueldo = false;
			if (opcionesEmpresaSeleccionada && opcionesEmpresaSeleccionada.includes(OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.TXT_REPORTE_VER_SUELDO)) {
				mostrarSueldo = true;
			}
			let respuesta = await ColaboradorService.descargarExcel(
				getUsuarioAutenticado().empresaSeleccionada.id,
				_accesoPlataforma,
				filtros["estado"],
				_tipoDocumento,
				filtros["colaborador"],
				filtros["documentoIdentidad"],
				filtros["codigoColaborador"],
				filtros["centroCosto"],
				filtros["fechaIngreso"],
				getUsuarioAutenticado().login,
				mostrarSueldo
			);
			setLoadingExportar(false);
			const filename = respuesta.headers.filename;
			saveAs(respuesta.data, filename);
		} catch (error) {
			setLoadingExportar(false);
			console.log(error);
			notification.error({
				message: "No hay colaboradores para exportar",
				description: error.response.data.mensaje,
			});
		}
	}

	async function handleOnclickExportarDatosAsync() {
		setLoadingExportarAsync(true);
		try {
			const _accesoPlataforma = filtros["accesoPlataforma"]?.map((p) =>
				p.replace("SI", true).replace("NO", false)
			);
			const _tipoDocumento = filtros["tipoDocumento"]?.map((p) =>
				p.replace("Carnet de Extranjería", "CARNET_EXTRANJERIA").replace("Pasaporte", "PASAPORTE")
			);
			const mostrarSueldo = !!(
				opcionesEmpresaSeleccionada &&
				opcionesEmpresaSeleccionada.includes(OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.TXT_REPORTE_VER_SUELDO)
			);

			const { jobId } = await ColaboradorService.iniciarDescargaExcelAsync(
				getUsuarioAutenticado().empresaSeleccionada.id,
				_accesoPlataforma,
				filtros["estado"],
				_tipoDocumento,
				filtros["colaborador"],
				filtros["documentoIdentidad"],
				filtros["codigoColaborador"],
				filtros["centroCosto"],
				filtros["fechaIngreso"],
				getUsuarioAutenticado().login,
				mostrarSueldo
			);

			const jobIdListo = await new Promise((resolve, reject) => {
				const intervalo = setInterval(async () => {
					try {
						const { estado, mensaje } = await ColaboradorService.consultarEstadoDescargaExcel(jobId);
						if (estado === "LISTO") {
							clearInterval(intervalo);
							resolve(jobId);
						} else if (estado === "ERROR") {
							clearInterval(intervalo);
							reject(new Error(mensaje ?? "Error generando el archivo"));
						}
					} catch (e) {
						clearInterval(intervalo);
						reject(e);
					}
				}, 3000);
			});

			const respuesta = await ColaboradorService.descargarExcelAsync(jobIdListo);
			const filename = respuesta.headers.filename;
			saveAs(respuesta.data, filename);
			setLoadingExportarAsync(false);
		} catch (error) {
			setLoadingExportarAsync(false);
			notification.error({
				message: "Error al exportar",
				description: error.message ?? "Error desconocido",
			});
		}
	}

	function onChangePagination(page) {
		setPaginaActual(page);
		actualizarData(page - 1);
	}

	const sortFieldMap = {
		nombreCompleto: "apellidoPaterno",
	};

	function onChangeTable(pagination, filters, sorter, extra) {
		if (extra?.action !== "sort") return;
		if (sorter && sorter.field && sorter.order) {
			const mongoField = sortFieldMap[sorter.field] ?? sorter.field;
			const dir = sorter.order === "descend" ? "desc" : "asc";
			const newSort = { field: mongoField, dir };
			setSortInfo(newSort);
			setPaginaActual(1);
			actualizarData(0, newSort);
		} else {
			const newSort = { field: undefined, dir: undefined };
			setSortInfo(newSort);
			setPaginaActual(1);
			actualizarData(0, newSort);
		}
	}

	const onClickLegajoColaborador = (colaboradorId) => {
		history.push(`/v3/legajos/${colaboradorId}`);
	};

	const handleGuardarNuevoDocumento = async () => {
		try {
			const valores = await formEditarDocumento.validateFields();
			setLoadingEditarDocumento(true);
			await ColaboradorService.actualizarNumeroDocumentoIdentidad({
				colaboradorId: colaboradorParaEditar.id,
				nuevoNumeroDocumentoIdentidad: valores.nuevoNumeroDocumentoIdentidad.trim(),
				empresaId: getUsuarioAutenticado().empresaSeleccionada.id,
			});
			setColaboradores(
				colaboradores.map((c) =>
					c.id === colaboradorParaEditar.id
						? { ...c, numeroDocumentoIdentidad: valores.nuevoNumeroDocumentoIdentidad.trim() }
						: c
				)
			);
			message.success("Número de documento actualizado correctamente.");
			setVisibleModalEditarDocumento(false);
			formEditarDocumento.resetFields();
		} catch (error) {
			if (error?.errorFields) return;
			message.error(
				error?.response?.data?.mensaje ??
					"No se pudo actualizar el número de documento. Intente nuevamente."
			);
		} finally {
			setLoadingEditarDocumento(false);
		}
	};

	const handleVerCV = async (colaborador) => {
		setColaboradorCV(colaborador);
		setCvDetalleEnvio(null);
		setLoadingCV(true);
		setVisibleModalCV(true);
		try {
			const detalleEnvio = await DetalleEnvioService.buscarUltimoCVColaborador(
				getUsuarioAutenticado().empresaSeleccionada.id,
				colaborador.numeroDocumentoIdentidad
			);
			setCvDetalleEnvio(detalleEnvio);
			console.log("detalleEnvio",detalleEnvio);
		} catch (error) {
			message.error("Error al buscar el CV.");
		} finally {
			setLoadingCV(false);
		}
	};

	const handleAbrirCVPdf = async () => {
		try {
			const resultado = await DetalleEnvioService.obtenerUrlDocumento(
				getUsuarioAutenticado().empresaSeleccionada.id,
				cvDetalleEnvio.id
			);
			setUrlCV(resultado.urlDocumento);
			setVisibleVisorCV(true);
		} catch (error) {
			message.error("Error al obtener el documento.");
		}
	};

	const handleCargarCV = async (file) => {
		setLoadingCargarCV(true);
		try {
			const formData = new FormData();
			formData.append("file", file);

			if (cvDetalleEnvio) {
				// Ya existe registro → carga el archivo sobre el detalleEnvio existente
				const usuario = getUsuarioAutenticado();
				formData.append("detalleEnvioId", cvDetalleEnvio.id);
				formData.append("numeroDocumentoIdentidad", usuario.numeroDocumentoIdentidad);
				formData.append("nombreCompleto", usuario.nombreCompleto);
				formData.append("guardarHistorico", "true");
				await DetalleEnvioService.cargarDocumento(formData);
			} else {
				// Sin registro previo → crea uno nuevo
				// formData.append("colaboradorId", colaboradorCV.id);
				// await DetalleEnvioService.cargarCVColaborador(formData);
			}

			message.success("CV cargado correctamente.");
			setVisibleModalCV(false);
			// Refresca el último documento vigente
			const detalleEnvio = await DetalleEnvioService.buscarUltimoCVColaborador(
				getUsuarioAutenticado().empresaSeleccionada.id,
				colaboradorCV.numeroDocumentoIdentidad
			);
			setCvDetalleEnvio(detalleEnvio);
		} catch (error) {
			message.error("Error al cargar el CV.");
		} finally {
			setLoadingCargarCV(false);
		}
	};

	const handleOnClickNotificarMensajeBienvenida = async () => {
		try {
			setLoadingNotificar(true);
			const respuesta = await ColaboradorService.notificarMensajeBienvenida();
			setLoadingNotificar(false);
			if (respuesta) {
				notification.success({
					message: "Notificación",
					description: "Colaboradores notificados correctamente",
				});
			} else
				notification.error({
					message: "Notificación",
					description: "No hay Colaboradores notificados",
				});
		} catch (error) {
			setLoadingNotificar(false);
		}
	};

	const handleOnclickExportarSeguimientoOnboarding = async () => {
		try {
			console.log("somos");
		} catch (error) {
			setLoadingNotificar(false);
		}
	};

	const handleOnClickMigrarExplomin = async () => {
		console.log("ingrese");
		try {
			setLoadingMigrar(true);
			const respuesta = await ColaboradorService.procesarMigracion();
			setLoadingMigrar(false);
			if (respuesta) {
				notification.success({
					message: "Migración",
					description: "Migración realizada correctamente",
				});
			} else
				notification.error({
					message: "Notificación",
					description: "No se pudo realizar la migración",
				});
		} catch (error) {
			setLoadingMigrar(false);
		}
	};

	const onClickBtnReportes = (e) => {
		if (e.key === "exportar-formulario") {
			setVisibleModalExportarFormulario(true);
		} else if (e.key === "descargar-fotos") {
			descargarFotos();
		} else if (e.key === "verificar-envio-documento") {
			setVisibleModalVerificacionEnvioDocumento(true);
		}
	};

	const onClickBtnImportar = (e) => {
		if (e.key === "importar-colaboradores") {
			handleOnClickCargaMasivaColaborador();
		} else if (e.key === "actualizar-colaboradores") {
			abrirDrawerActualizarColaboradores();
		} else if (e.key === "actualizar-aprobadores-nivel") {
			setVisibleModalActualizarAprobadores(true);
		}
	};

	const descargarFotos = async () => {
		setEventoDescarga({ estado: 'loading', mensaje: 'Se está procesando la descarga de fotos. Espere un momento...' });
		const accesoPlataforma = filtros["accesoPlataforma"]?.map((p) => {
			return p.replace("SI", true).replace("NO", false);
		});
		const tipoDocumento = filtros["tipoDocumento"]?.map((p) => {
			return p.replace("Carnet de Extranjería", "CARNET_EXTRANJERIA").replace("Pasaporte", "PASAPORTE");
		});

		ExportadorService
			.descargarFotos({
				accesoPlataforma: accesoPlataforma,
				estado: filtros["estado"],
				tipoDocumento: tipoDocumento,
				colaborador: filtros["colaborador"],
				documentoIdentidad: filtros["documentoIdentidad"],
				codigoColaborador: filtros["codigoColaborador"],
				centroCosto: filtros["centroCosto"],
				fechaIngreso: filtros["fechaIngreso"],
				proyecto: filtros["proyecto"],
				reclutador: filtros["reclutador"],
				login: getUsuarioAutenticado().login
			})
			.then((response) => {
				console.log("response descarga fotos....", response)
				setEventoDescarga({ estado: undefined });
				saveAs(response.url);
			})
			.catch((error) => {
				console.error("error al descargar fotos..", error);
				setEventoDescarga({ estado: undefined });
			})
	}

	const getItemsBotonDescargar = () => {
		const items = [];

		if (existeOpcion("mantenimiento.colaborador.boton.exportar-formulario")) {
			items.push({
				label: "Exportar Formulario",
				key: "exportar-formulario",
				icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
			});
		}

		if (existeOpcion("mantenimiento.colaborador.boton.descargar-fotos")) {
			items.push({
				label: "Descargar Fotos",
				key: "descargar-fotos",
				icon: <PictureOutlined style={{ fontSize: "18px" }} />,
			});
		}

		items.push({
			label: "Verificar Envío de Documento",
			key: "verificar-envio-documento",
			icon: <FileSearchOutlined style={{ fontSize: "18px" }} />,
		});

		return items;
	}

	const getItemsBotonImportar = () => {
		const items = [];

		items.push({
			label: "Importar colaboradores",
			key: "importar-colaboradores",
			icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
		});

		// items.push({
		// 	label: "Actualizar colaboradores",
		// 	key: "actualizar-colaboradores",
		// 	icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
		// });

		if (isSDF || isSDFEnergia) {
			items.push({
				label: "Actualizar aprobadores por nivel",
				key: "actualizar-aprobadores-nivel",
				icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
			});
		}

		return items;
	}

	function handleOnClickCargaResumenColaborador() {
		setVisibleVisualizarResumen(true);
	}

	return (
		<Container
			icono={<UnorderedListOutlined />}
			titulo="Colaborador"
			botonExtra={
				<Space>
					<Button loading={loadingExportar} icon={<LineChartOutlined />} onClick={handleOnClickCargaResumenColaborador}>
						Resumen
					</Button>
					{getItemsBotonDescargar().length > 0
						&& (
							<Dropdown.Button
								menu={{
									items: getItemsBotonDescargar(),
									onClick: onClickBtnReportes,
								}}
								icon={<CaretDownOutlined />}
								trigger={["click"]}
								arrow
							>
								Descargar
							</Dropdown.Button>
						)
					}

					{existeOpcion("mantenimiento.colaborador.boton.importar")
						&& (
							// <Button icon={<UploadOutlined />} onClick={handleOnClickCargaMasivaColaborador}>
							// 	Importar
							// </Button>
							<Dropdown.Button
								menu={{
									items: getItemsBotonImportar(),
									onClick: onClickBtnImportar,
								}}
								onClick={handleOnClickCargaMasivaColaborador}
								icon={<CaretDownOutlined />}
								trigger={["click"]}
								arrow
							>
								Importar
							</Dropdown.Button>
						)
					}

					{existeOpcion("mantenimiento.colaborador.boton.exportar")
						&& (
							<Button loading={loadingExportar} icon={<DownloadOutlined />} onClick={handleOnclickExportarDatos}>
								Exportar
							</Button>
						)
					}

					{/* {existeOpcion("mantenimiento.colaborador.boton.exportar")
						&& (
							<Button loading={loadingExportarAsync} icon={<DownloadOutlined />} onClick={handleOnclickExportarDatosAsync}>
								Exportar Asíncrono
							</Button>
						)
					} */}

					{
						isGlore && (
								<Button 
									icon={<SyncOutlined />} 
									onClick={handleOnClickActualizarEstadoRegistro}
								>
									Actualizar estado
								</Button>
						)
					}
					
					{existeOpcion("mantenimiento.colaborador.boton.crear-colaborador")
						&& (
							<Button type="primary" icon={<PlusOutlined />} onClick={handleOnClickCrearColaborador}>
								Crear Colaborador
							</Button>
						)
					}

					{isSDFEnergia && (
						<Button  icon={<PlusOutlined />} onClick={handleOnClickNotificarMensajeBienvenida}>
													Enviar mensaje Bienvenida
										</Button>
					)}
					
				</Space>
			}
		>
			<Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} />} spinning={loading} tip="Cargando...">

				{eventoDescarga && eventoDescarga.estado === "loading" &&
					<Alert message={eventoDescarga?.mensaje} type="info" showIcon icon={<Loading3QuartersOutlined spin />} />
				}
				<FiltroBusqueda setFiltros={setFiltros} filtro={filtros} reset={reset} filtroActual={filtros} />
				<Table
					rowKey={(fila) => fila.id}
					columns={columnas}
					dataSource={colaboradores}
					onChange={onChangeTable}
					pagination={{
						pageSize: [10],
						total: totalPagina,
						current: paginaActual,
						showTotal: (total) => `Total ${total} colaboradores`,
						onChange: (page, pageSize) => onChangePagination(page, pageSize),
					}}
					size="small"
					bordered={true}
					style={{ marginTop: "10px" }}
				/>
				{/* </Card> */}
			</Spin>

			<ModalCargaMasiva visibleModal={visibleModal} onCerrarModal={cerrarModal} />
			<ModalRestablecerClave colaborador={colaboradorSeleccionado} />
			<ModalHistorialColaborador colaborador={colaboradorSeleccionado} />
			<ModalReingreso colaboradorSeleccionado={colaboradorSeleccionado} setColaboradores={setColaboradores} colaboradores={colaboradores} />
			<ModalHabilitarOpcionPortalColaborador objetoColaboradorSeleccionado={objetoColaboradorSeleccionado} colaboradorSeleccionado={colaboradorSeleccionado} setColaboradores={setColaboradores} colaboradores={colaboradores} />
			<ModalExportarFormulario />
			<ModalReporteVerificacionEnvioDocumento />
			<ModalVisualizarResumen />
			<DrawerActualizarColaboradores />
			<ModalActualizarEstadoRegistro
                visible={visibleModalActualizarEstado}
                onCancel={handleCerrarModalActualizarEstado}
                onSuccess={handleSuccessActualizarEstado}
            />
			<ModalActualizarAprobadoresNivel
				visible={visibleModalActualizarAprobadores}
				onCancel={() => setVisibleModalActualizarAprobadores(false)}
			/>

			<Modal
				title="Editar Número de Documento de Identidad"
				open={visibleModalEditarDocumento}
				onOk={handleGuardarNuevoDocumento}
				onCancel={() => {
					setVisibleModalEditarDocumento(false);
					formEditarDocumento.resetFields();
				}}
				okText="Guardar"
				cancelText="Cancelar"
				confirmLoading={loadingEditarDocumento}
				width={420}
			>
				{colaboradorParaEditar && (
					<Form form={formEditarDocumento} layout="vertical" style={{ marginTop: 8 }}>
						<Form.Item label="Colaborador">
							<Input value={colaboradorParaEditar.nombreCompleto} disabled />
						</Form.Item>
						<Form.Item label="Número de documento actual">
							<Input value={colaboradorParaEditar.numeroDocumentoIdentidad} disabled />
						</Form.Item>
						<Form.Item
							label="Nuevo número de documento"
							name="nuevoNumeroDocumentoIdentidad"
							rules={[
								{ required: true, message: "Ingrese el nuevo número de documento" },
								{ min: 8, message: "Mínimo 8 caracteres" },
							]}
						>
							<Input
								placeholder="Ingrese el nuevo número"
								maxLength={20}
								autoComplete="off"
								autoFocus
							/>
						</Form.Item>
					</Form>
				)}
			</Modal>

			<Modal
				title={`CV - ${colaboradorCV?.nombreCompleto}`}
				open={visibleModalCV}
				onCancel={() => setVisibleModalCV(false)}
				footer={null}
				width={520}
			>
				{loadingCV ? (
					<div style={{ textAlign: "center", padding: 32 }}>
						<Spin tip="Buscando CV..." />
					</div>
				) : cvDetalleEnvio?.estadoVistaColaborador === "FIRMADO" ? (
					<>
						<Descriptions column={1} size="small" bordered>
							<Descriptions.Item label="Documento">
								{cvDetalleEnvio.nombreDocumento}
							</Descriptions.Item>
							<Descriptions.Item label="Fecha de carga">
								{(cvDetalleEnvio.fechaCarga || cvDetalleEnvio.fechaEnvio)
									? new Date(cvDetalleEnvio.fechaCarga ?? cvDetalleEnvio.fechaEnvio).toLocaleString("es-PE", {
											day: "2-digit", month: "2-digit", year: "numeric",
											hour: "2-digit", minute: "2-digit",
									  })
									: "-"}
							</Descriptions.Item>
						</Descriptions>
						<Divider />
						<div style={{ display: "flex", gap: 8 }}>
							<Button icon={<FilePdfOutlined />} type="primary" onClick={handleAbrirCVPdf}>
								Ver PDF
							</Button>
							<Upload
								accept=".pdf"
								beforeUpload={(file) => { handleCargarCV(file); return false; }}
								maxCount={1}
								showUploadList={false}
							>
								<Button icon={<UploadOutlined />} loading={loadingCargarCV}>
									Actualizar CV
								</Button>
							</Upload>
						</div>
					</>
				) : (
					<>
						<Alert
							type="info"
							message="Este colaborador no tiene CV cargado."
							style={{ marginBottom: 16 }}
						/>
						<Upload
							accept=".pdf"
							beforeUpload={(file) => { handleCargarCV(file); return false; }}
							maxCount={1}
							showUploadList={false}
						>
							<Button icon={<UploadOutlined />} loading={loadingCargarCV}>
								Cargar CV (PDF)
							</Button>
						</Upload>
					</>
				)}
			</Modal>

			{visibleVisorCV && (
				<ModalVisorPdf
					titulo={`CV - ${colaboradorCV?.nombreCompleto}`}
					urlPdf={urlCV}
					visible={visibleVisorCV}
					onCerrar={() => { setVisibleVisorCV(false); setUrlCV(null); }}
				/>
			)}
		</Container>
	);
}
